import moment from 'moment';
import { useContext } from 'react';
import { DashboardResultsContext } from '../../DashboardResults.context';

export default () => {
  const { currentDates, setCurrentDates } = useContext(DashboardResultsContext);

  const [from, to] = currentDates;

  return (
    <>
      <div
        className="dashboard__results-header-item"
        onClick={() => {
          setCurrentDates([
            moment(from).subtract(1, 'week').toDate(),
            moment(to).subtract(1, 'week').toDate(),
          ]);
        }}>
        <span>{'<'}</span>
      </div>
      <div className="dashboard__results-header-item dashboard__results-header-item--active">
        <span>
          {moment(from).format('DD/MM/YYYY')} - {moment(to).format('DD/MM/YYYY')}
        </span>
      </div>
      <div
        className="dashboard__results-header-item"
        onClick={() => {
          setCurrentDates([
            moment(from).add(1, 'week').toDate(),
            moment(to).add(1, 'week').toDate(),
          ]);
        }}>
        <span>{'>'}</span>
      </div>
    </>
  );
};
